/** Thai strings for sign-in, accounts and cloud save (ui/account.ts, networking/cloud.ts). */
export const ACCOUNT: Record<string, string> = {
  // Sign-in screen
  'Save your notebook so it is never lost, and open it on any device.': 'เซฟสมุดไว้ไม่ให้หาย และเปิดเล่นต่อได้ทุกเครื่อง',
  'Or play as a guest: your notebook is saved too, and you can link Google later in Settings.': 'หรือเล่นแบบ Guest ก็เซฟเหมือนกัน และผูก Google ทีหลังได้ในหน้าตั้งค่า',
  'Play as a guest: your notebook is saved to the game server too.': 'เล่นแบบ Guest สมุดจะถูกเซฟไว้บนเซิร์ฟเวอร์เกมด้วย',
  'Play as guest': 'เล่นแบบ Guest',
  'Sign in with Google (ask a grown-up)': 'เข้าด้วย Google (ให้ผู้ใหญ่ช่วย)',
  'Loading Google…': 'กำลังโหลด Google…',
  'Google sign-in is not available right now.': 'ตอนนี้ยังเข้าด้วย Google ไม่ได้',
  'Google sign-in is not set up on this server yet.': 'เซิร์ฟเวอร์นี้ยังไม่ได้เปิดการเข้าด้วย Google',
  'Signing in with Google needs a grown-up.': 'การเข้าด้วย Google ต้องให้ผู้ใหญ่ช่วย',
  'Sign in with Google': 'เข้าด้วย Google',
  'Sign in with Google to open your notebook.': 'เข้าด้วย Google เพื่อเปิดสมุดของคุณ',
  'Link Google account': 'ผูกบัญชี Google',
  'Link a Google account to this notebook, so you can open it on any device.': 'ผูกบัญชี Google กับสมุดเล่มนี้ จะได้เปิดเล่นต่อได้ทุกเครื่อง',
  'Signed in! Your notebook is now saved to your Google account.': 'เข้าสู่ระบบแล้ว! สมุดของคุณถูกเซฟไว้กับบัญชี Google แล้ว',
  'Welcome back, {name}!': 'ยินดีต้อนรับกลับมา {name}!',
  'Could not sign in': 'เข้าสู่ระบบไม่สำเร็จ',
  'Linked to {email}. Sign in with Google on any device to keep playing.': 'ผูกกับ {email} แล้ว เข้าด้วย Google ที่เครื่องไหนก็เล่นต่อได้',
  'Could not link Google': 'ผูก Google ไม่สำเร็จ',
  'That Google account already has a notebook': 'บัญชี Google นี้มีสมุดอยู่แล้ว',
  'Open the notebook saved in that Google account on this device instead? You will be asked which notebook to keep.': 'จะเปิดสมุดที่อยู่ในบัญชี Google นั้นบนเครื่องนี้แทนไหม? เกมจะถามว่าจะเก็บสมุดเล่มไหน',
  'Open it': 'เปิดเลย',
  // Settings → Account
  Account: 'บัญชี',
  'Signed in as {name}…': 'เข้าสู่ระบบในชื่อ {name}…',
  'Not signed in: this notebook lives only in this browser.': 'ยังไม่ได้เข้าสู่ระบบ: สมุดเล่มนี้อยู่แค่ในเบราว์เซอร์นี้',
  'Play as guest (save online)': 'เล่นแบบ Guest (เซฟออนไลน์)',
  'Signed in with Google ({email}) as {name}.': 'เข้าด้วย Google ({email}) ในชื่อ {name}',
  'Guest account ({name}). Link Google so you never lose this notebook.': 'บัญชี Guest ({name}) ผูก Google ไว้ สมุดจะได้ไม่หาย',
  'Signed in as {name} (account details need the server).': 'เข้าสู่ระบบในชื่อ {name} (ดูรายละเอียดบัญชีได้เมื่อต่อเซิร์ฟเวอร์ได้)',
  'Sign out': 'ออกจากระบบ',
  'Sign out on this device?': 'ออกจากระบบบนเครื่องนี้ไหม?',
  'Your notebook stays in your Google account. This device starts a fresh notebook until you sign in again.': 'สมุดของคุณยังอยู่ในบัญชี Google เครื่องนี้จะเริ่มสมุดเล่มใหม่จนกว่าจะเข้าสู่ระบบอีกครั้ง',
  'Signed out.': 'ออกจากระบบแล้ว',
  'Saving to the cloud…': 'กำลังเซฟขึ้นคลาวด์…',
  'Saved to the cloud.': 'เซฟขึ้นคลาวด์แล้ว',
  'Cloud save will retry when the server is reachable.': 'จะลองเซฟขึ้นคลาวด์ใหม่เมื่อต่อเซิร์ฟเวอร์ได้',
  'This server does not keep cloud saves.': 'เซิร์ฟเวอร์นี้ไม่มีระบบเซฟคลาวด์',
  // Two notebooks
  'Two notebooks found': 'เจอสมุดสองเล่ม',
  'This device and your account have different notebooks. Which one do you want to keep?': 'สมุดในเครื่องนี้กับในบัญชีไม่ตรงกัน จะเก็บเล่มไหนไว้?',
  'This device': 'เครื่องนี้',
  'Your account (saved {when})': 'ในบัญชี (เซฟเมื่อ {when})',
  'The other notebook will be replaced.': 'อีกเล่มจะถูกแทนที่',
  'Keep this device': 'เก็บของเครื่องนี้',
  'Use my account': 'ใช้ของในบัญชี',
  '{name}, level {level}': '{name} เลเวล {level}',
  'No hero yet': 'ยังไม่มีฮีโร่',
  '{n} monsters': 'มอนสเตอร์ {n} ตัว',
  '{n} coins': '{n} เหรียญ',
  // Updates & full screen (app/updates.ts, app/fullscreen.ts)
  'A new version of Paper Legends is ready.': 'Paper Legends มีเวอร์ชันใหม่แล้ว',
  'Update now': 'อัปเดตเลย',
  'Full screen': 'เต็มจอ',
  'Full screen on phones (the first tap opens it)': 'เต็มจอบนมือถือ (แตะครั้งแรกจะเปิดเต็มจอ)',
  'Play full screen': 'เล่นแบบเต็มจอ',
  'For full screen on iPhone, add the game to your home screen:': 'ถ้าอยากเล่นเต็มจอบน iPhone ให้เพิ่มเกมลงหน้าจอหลัก:',
  'Tap the Share button (the square with an arrow).': 'แตะปุ่มแชร์ (รูปสี่เหลี่ยมมีลูกศรชี้ขึ้น)',
  'Choose "Add to Home Screen".': 'เลือก "เพิ่มไปยังหน้าจอโฮม"',
  'Open Paper Legends from your home screen.': 'เปิด Paper Legends จากไอคอนบนหน้าจอโฮม',
  'Got it': 'เข้าใจแล้ว',
  // Main menu shortcuts
  Shop: 'ร้านค้า',
  'World Chat': 'แชทโลก',
  Chat: 'แชท',
  '{name} · account': '{name} · บัญชี',
  '{name} · Google ✓': '{name} · Google ✓',
  '{name} · Guest — link Google': '{name} · Guest — ผูก Google',
};
